import script from "./DealCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DealCard.vue?vue&type=script&setup=true&lang=js"

import "./DealCard.vue?vue&type=style&index=0&id=f0ccf920&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ccf920"]])

export default __exports__